import { Component, OnInit } from '@angular/core';
import { WebSocketServiceService } from './webappnotification.service';
import {ToastrService} from 'ngx-toastr';

//for chat
import Chatkit from '@pusher/chatkit-client';
import axios from 'axios';
import { Router } from '@angular/router';


@Component({
  selector: 'notif-webappnotification',
  templateUrl: './webappnotification.component.html',
  styleUrls: ['./webappnotification.component.css']
})
export class WebappnotificationComponent implements OnInit {

  public notifications = "";
  title = 'Web App User Notification ';
 compteur =0;
 public notifcount =0;
 emplist: any[] = []; 
 chaine="true";
 public emplist1: any[] = [];

 show: boolean = false;

  constructor(private webSocketService: WebSocketServiceService,private toastr: ToastrService,private router:Router) {

    // Open connection with server socket
    let stompClient = this.webSocketService.connect();
    stompClient.connect({}, frame => {

      // Subscribe to notification topic
      stompClient.subscribe('/topic/notification', notifications => {

        // Update notifications attribute with the recent messsage sent from the server
        this.notifications = notifications.body;
        this.emplist.push(this.notifications);
        this.emplist1.push(this.notifications);
        //console.log(this.emplist);
      })
    });

    
    //console.log("")
  }
  ngOnInit() {
  }


  showSuccess(){
    this.emplist.forEach(element => {
        this.toastr.warning(element,'Notification');
      console.log(element);
      this.notifcount++;
    });
    this.emplist=[];
   
  }

}
